import FormData from 'form-data'

import request from '@/utils/request'
import serialize from '@/utils/serialize'

export function getCourses(data) {
  return request({
    url: '/courses' + serialize(data),
    method: 'get'
  })
}

export function getStudents(data) {
  return request({
    url: '/courses/students' + serialize(data),
    method: 'get'
  })
}

export function getHomeworks(data) {
  return request({
    url: '/courses/homeworks' + serialize(data),
    method: 'get'
  })
}

export function reviewHomework(data) {
  return request({
    url: '/courses/homeworks/review' + serialize(data.query),
    method: 'post',
    data: data.body
  })
}

export function getRatings(data) {
  return request({
    url: '/rating' + serialize(data),
    method: 'get'
  })
}

export function getWebinars(data) {
  return request({
    url: '/webinars' + serialize(data),
    method: 'get'
  })
}

export function uploadWebinarThumbnail(data) {
  const upload = new FormData()
  upload.append('file', data.file)

  return request({
    url: '/webinars/thumbnail',
    method: 'put',
    timeout: false,
    data: upload,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function createWebinar(data) {
  return request({
    url: '/webinars',
    method: 'post',
    data
  })
}

export function updateWebinar(data) {
  return request({
    url: '/webinars',
    method: 'put',
    data
  })
}

export function getCommissions(data) {
  return request({
    url: '/commissions' + serialize(data),
    method: 'get'
  })
}

export function getCommissionStatistics(data) {
  return request({
    url: '/commissions/statistics' + serialize(data),
    method: 'get'
  })
}
